module.exports = __webpack_public_path__ + "img/task-manager-icon-dark.e24570cc.svg";